import { generateKeyPair } from 'crypto';
import Cookies from 'js-cookie';
import JSEncrypt from 'jsencrypt';
import keypair from 'keypair'
import { makeId } from './HelperService';
// import Cryptr from 'cryptr'
import { CryptoMsg } from '../models/app/CryptoMsg';
// import { enc } from '../StApp';
import { aesGcmDecrypt, aesGcmEncrypt } from './aesGcmCrypto';
import { CryptoString } from '../models/app/CryptoString';
import { SHA1 } from './hashFunctions';
import Logger from './Logger';
// import JSEncrypt from 'node-jsencrypt'

export abstract class CryptoService{

    abstract get publicKey(): string|null|undefined

    abstract get privateKey(): string|null|undefined

    abstract initKeys(): void

    abstract decrypt(cryptoMsg: CryptoMsg): Promise<CryptoString>

    abstract encrypt(data: string, userPubKey: string): Promise<CryptoMsg>

    abstract verify(str: string, signature: string, pubKey: string, hashFunc: (s:string)=>void ): boolean

    abstract dummyEncrypt(str: string, userPubKey: string): CryptoMsg

    abstract generateKeys(): void

    abstract signAnyMessage(data: string): string

    abstract dumpKeys(): void
}

export class CryptoServiceImpl extends CryptoService{

    privateKey: string|null|undefined
    publicKey: string|null|undefined
    private jsEncrypt = new JSEncrypt({log: true})
    private jsDecrypt = new JSEncrypt({log: true})

    constructor(){
        super()
        this.initKeys()

    }

    initKeys(){
         
        if(Cookies.get('privateKey')){
            this.privateKey = Cookies.get('privateKey')!
            this.publicKey = Cookies.get('publicKey')!
            this.jsDecrypt.setPrivateKey(this.privateKey)
            
        } 
        
    }

    generateKeys(){
        if(this.privateKey == null){
            //const pair = keypair({bits: 1024})
            const crypt = new JSEncrypt()
            this.privateKey = crypt.getPrivateKey();
            this.publicKey = crypt.getPublicKey();
            this.jsDecrypt.setPrivateKey(this.privateKey)
            //Save to Cookie
            Cookies.set('publicKey', this.publicKey, { expires: 365 })
            Cookies.set('privateKey', this.privateKey, { expires: 365 })
        }
        

    }

    dumpKeys(){
        this.privateKey = null
        this.publicKey = null
        Cookies.remove('publicKey')
        Cookies.remove('privateKey')
        this.jsEncrypt = new JSEncrypt({log: true})
        this.jsDecrypt = new JSEncrypt({log: true})
       // this.crypt = new JSEncrypt()
    }

    async decrypt(cryptoMsg: CryptoMsg): Promise<CryptoString> {
        //  const localDec = new JSEncrypt()
        //  localDec.setPrivateKey(this.privateKey!)
        // const enc = localDec.encrypt('hi')
        // console.log(enc)
        // if(enc)
        // console.log(localDec.decrypt(enc))

        this.jsDecrypt.setPrivateKey(this.privateKey!)
        // const jsEnc = new JSEncrypt()
        // jsEnc.setPrivateKey(AppCrypto.privateKey!)
        //console.log(this.privateKey)
        let key = cryptoMsg.key
        const decryptedKey = this.jsDecrypt.decrypt(key)
        if(decryptedKey)
         var cryptr = 'x'
        else
         throw "Unable to decrypt key" 

        const decryptedMsg = await aesGcmDecrypt(cryptoMsg.data, decryptedKey)
        //return this.crypt.decrypt(data)
        //console.log(decryptedMsg)
        if(decryptedMsg)
         return {
             decryptedString: decryptedMsg,
             encKey: decryptedKey,
             signature: cryptoMsg.signature!
         }
        else
         throw 'Unable to decrypt' 
    }

    async encrypt(data: string, userPubKey:string): Promise<CryptoMsg> {
        //console.log(userPubKey)
        this.jsEncrypt.setPublicKey(userPubKey)

        //Symmetrically encrypt the data
        //generate random id
        const random = makeId(10)
        //const cryptr = new Cryptr(random)
        const encryptedData = await aesGcmEncrypt(data, random)
        //console.log('Symm Encrypted data '+ encryptedData)
        const encryptedKey = this.jsEncrypt.encrypt(random)
        //console.log('Asymm encryption '+encryptedKey)
        const signature = this.jsDecrypt.sign(random, SHA1, 'sha1' ) as string
        
        if(encryptedData && encryptedKey)
         return {
             data: encryptedData,
             key: encryptedKey,
             signature
         }
        else
         throw 'Unable to encrypt'
    }

    verify(str: string, signature: string,pubKey: string, hashFunc: (s: string) => void): boolean {
        this.jsEncrypt.setPublicKey(pubKey)

        return this.jsEncrypt.verify(str, signature, SHA1 )
    }

    signAnyMessage(data: string): string {
        if(this.privateKey)
        this.jsDecrypt.setPrivateKey(this.privateKey)

        return this.jsDecrypt.sign(data, SHA1, 'sha1' ) as string
    }


    dummyEncrypt(data: string, userPubKey:string): CryptoMsg{
        return {
            data: 'kiopdidod',
            key: 'opunduisn'
        }
    }


}



const AppCrypto: CryptoService = new CryptoServiceImpl()
export default AppCrypto
